// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// LeadStatusDetail — source: shared/config/lead_status_details.config.json
import type { ConfigStatusTone } from './config-status-tone';

export const LEAD_STATUS_DETAIL_VALUES = ["clicked", "call_connected", "replied", "unqualified", "bad_timing", "do_not_contact"] as const;
export type LeadStatusDetail = (typeof LEAD_STATUS_DETAIL_VALUES)[number];

export const leadStatusDetailTone: Record<LeadStatusDetail, ConfigStatusTone> = {
  "clicked": "info",
  "call_connected": "success",
  "replied": "success",
  "unqualified": "error",
  "bad_timing": "warning",
  "do_not_contact": "error",
};

export const leadStatusDetailGroup: Record<LeadStatusDetail, string> = {
  "clicked": "engaged",
  "call_connected": "engaged",
  "replied": "engaged",
  "unqualified": "closed",
  "bad_timing": "closed",
  "do_not_contact": "closed",
};

export const leadStatusDetailManuallySettable: Record<LeadStatusDetail, true | false> = {
  "clicked": true,
  "call_connected": true,
  "replied": true,
  "unqualified": true,
  "bad_timing": true,
  "do_not_contact": false,
};

